// ET colour codes (^1red ^7white ...) in map long names and player names.

/** g_color_table, indexed by ColorIndex(c) = (c - '0') & 31. */
const TABLE: [number, number, number][] = [
  [0, 0, 0],
  [1, 0, 0],
  [0, 1, 0],
  [1, 1, 0],
  [0, 0, 1],
  [0, 1, 1],
  [1, 0, 1],
  [1, 1, 1],
  [1, 0.5, 0],
  [0.5, 0.5, 0.5],
  [0.75, 0.75, 0.75],
  [0.75, 0.75, 0.75],
  [0, 0.5, 0],
  [0.5, 0.5, 0],
  [0, 0, 0.5],
  [0.5, 0, 0],
  [0.5, 0.25, 0],
  [1, 0.6, 0.1],
  [0, 0.5, 0.5],
  [0.5, 0, 0.5],
  [0, 0.5, 1],
  [0.5, 0, 1],
  [0.2, 0.6, 0.8],
  [0.8, 1, 0.8],
  [0, 0.4, 0.2],
  [1, 0, 0.2],
  [0.7, 0.1, 0.1],
  [0.6, 0.2, 0],
  [0.8, 0.6, 0.2],
  [0.6, 0.6, 0.2],
  [1, 1, 0.75],
  [1, 1, 0.5],
];

export interface ColorSpan {
  text: string;
  /** CSS colour, null = default text colour. */
  color: string | null;
}

/** Splits text at colour codes; very dark colours are lifted so they stay readable on the dark UI. */
export function parseColors(text: string): ColorSpan[] {
  const out: ColorSpan[] = [];
  let color: string | null = null;
  let current = '';
  for (let i = 0; i < text.length; i++) {
    if (text[i] === '^' && i + 1 < text.length && text[i + 1] !== '^') {
      if (current) out.push({ text: current, color });
      current = '';
      const [r, g, b] = TABLE[(text.charCodeAt(i + 1) - 48) & 31];
      const lift = Math.max(0, 0.45 - (0.3 * r + 0.59 * g + 0.11 * b));
      const c = (v: number) => Math.round(Math.min(1, v + lift) * 255);
      color = r === 1 && g === 1 && b === 1 ? null : `rgb(${c(r)}, ${c(g)}, ${c(b)})`;
      i++;
      continue;
    }
    current += text[i];
  }
  if (current) out.push({ text: current, color });
  return out;
}

export function stripColors(text: string): string {
  return parseColors(text)
    .map((s) => s.text)
    .join('');
}
